import styled from 'styled-components';
import { breakpoint } from '@zocdoc/components/src/grid';

const ContainerDiv = styled.div`
    box-sizing: border-box;
    display: ${props => props.alwaysVisible ? 'block' : 'none'};

    ${breakpoint.small} {
        display: flex;
        padding-left: 8% !important;
        padding-right: 8% !important;
        padding-bottom: 60px;
    }

    ${breakpoint.medium} {
        height: 720px;
    }
`;

export default ContainerDiv;
